import React from 'react';
import { Input, InputProps } from 'antd';
import type { TextAreaProps } from 'antd/es/input';
import { dimensions, typography } from '@doer/frontend-components/theme';

type FormInputSize = 'XS' | 'S' | 'L';

const FONT_SIZES: Record<FormInputSize, number> = { XS: 12, S: 14, L: 14 };

const baseStyle = (size: FormInputSize): React.CSSProperties => ({
  fontFamily: typography.fontFamily.ui,
  fontSize: FONT_SIZES[size],
  height: dimensions.controlHeight[size.toLowerCase() as 'xs' | 'sm' | 'lg']
});

interface FormInputProps extends Omit<InputProps, 'size'> {
  size?: FormInputSize;
}

export const FormInput: React.FC<FormInputProps> = ({ size = 'S', style, ...rest }) => (
  <Input {...rest} style={{ ...baseStyle(size), ...style }} />
);

interface FormTextAreaProps extends Omit<TextAreaProps, 'size'> {
  size?: FormInputSize;
}

export const FormTextArea: React.FC<FormTextAreaProps> = ({ size = 'S', style, ...rest }) => (
  <Input.TextArea
    {...rest}
    style={{
      fontFamily: typography.fontFamily.ui,
      fontSize: FONT_SIZES[size],
      ...style
    }}
  />
);
